//Regular Expressions

/**@description Matches anything that is not a digit at any point within a string */
export const NON_DIGITS_PATTERN = /\D/g;

/**@description Matches if a string ONLY contains digits */
export const ONLY_DIGITS_PATTERN = /^\d+$/;

/**@description Must be exactly 6 digits */
export const COST_CENTER_PATTERN = /^[0-9]{6}$/;

/**@description 0 to 6 digits (for UI validation as you type) */
export const COST_CENTER_UI_PATTERN = /^[0-9]{0,6}$/;

/**@description checks that only numbers and/or numbers with a single decimal are allowed. */
export const ONLY_NUMBER_OR_DECIMAL_PATTERN = /^([1-9]\d*(\.|)\d*|0?(\.|)\d*[1-9]\d*|d*(\.|)\d*)$/;

/**@description Matches `MM_DD_YY` and excludes invalid date numbers (like a month greater than 12) */
export const WEEK_ENDING_DATE_PATTERN = /^(0[1-9]|1[0-2])_(0[1-9]|[12][0-9]|3[01])_[0-9]{2}$/;

/**@description Matches `YYYY-MM-DDTHH:mm:ss` */
export const ODATA_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;

/**@description Matches `MM-DD-YYYY` and excludes invalid date numbers (like a month greater than 12) */
export const TOR_DATE_PATTERN = /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-[0-9]{4}$/;

/**@description Matches `YYYY-MM-DD` and excludes invalid date numbers (like a month greater than 12). All years must be from this century: 20xx */
export const ISO_DATE_PATTERN = /^20[0-9]{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;

/**
 * ISO 8601 Date-Time Regex
 *
 * Matches ISO 8601 strings with:
 * - Date only: YYYY-MM-DD (years 2000–2099)
 * - Optional time: Thh:mm
 * - Optional seconds: :ss
 * - Optional fractional seconds: .sss (up to 9 digits)
 * - Optional timezone: Z or ±hh:mm
 *
 * @example Matches:
 *   "2025-04-09"
 *   "2025-04-09T14:30"
 *   "2025-04-09T14:30:00"
 *   "2025-04-09T14:30:00.123"
 *   "2025-04-09T14:30:00Z"
 *   "2025-04-09T14:30:00+02:00"
 *   "2025-04-09T14:30:00.123456789-05:00"
 *
 * @example Does NOT match:
 *   "1999-12-31"                  // Year before 2000
 *   "2025-04-09 14:30"            // Space instead of 'T'
 *   "2025/04/09"                  // Wrong separators
 *   "2025-04-09T14"               // Missing minutes
 */
export const ISO_DATE_PATTERN_ALL =
  /^20\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])(?:T([01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d{1,9})?)?(?:Z|[+-][01]\d:[0-5]\d)?)?$/;

/**
 * @description Matches Unix datetime formats like `/Date(1234)/`
 * This contains a regex match group for just the numbers in case that needs to be accessed.
 * ```
 * const match = '/Date(1234)/'.exec(UNIX_DATE_PATTERN);
 * console.log(match[1]); // => '1234'
 * ```*/
export const UNIX_DATE_PATTERN = /^\/Date\((\d+)\)\/$/;

/**@description Determines if a string is YYYYMMDD date number string. Validates length, year begins with 20, month is 01-12, and day is 01-31 */
export const YYYYMMDD_PATTERN = /^(20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/;

/**@description Just makes sure that a string has only one period. */
export const PROJECT_DEFINITION_PATTERN = /^(?:[^.]*\.){2,}.*$/;

/**@description Employee numbers can only be numbers between 1 and 8 characters long */
export const EMPLOYEE_NUMBER_PATTERN = /^\d{1,8}$/;

/**
 * @description Determines if a string is a valid 24H time in HH:MM format with leading zeros.
 * @example `23:30` and `08:05` are valid
 * @example `24:00` or `66:66` are invalid
 */
export const TIME_24_HOUR_PATTERN = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

/**
 * @description Matches strings that contain ONLY numbers and letters, SEE NOTE
 * @todo THIS IS WIP PATTERN, AS WE LEARN MORE ABOUT S4 COST CENTERS AND GET FINALIZED DATA
 * THIS WILL HAVE MORE ADDED ON FOR BETTER CHECKING.
 */
export const S4_COST_CENTER_PATTERN = /^[0-9a-zA-Z]+$/;

/**
 * Regular expression to check if a string contains **only the digit `0` or is empty**.
 *
 * ✅ Matches:
 * - ''               (empty string)
 * - '0'
 * - '00'
 * - '000000'
 *
 * ❌ Does NOT match:
 * - '01'
 * - '1000'
 * - '0a0'
 *
 * This is useful in cases where both an empty string and a zero-only string
 * should be treated as "zero-equivalent" or insignificant.
 *
 * @example
 * /^0*$/.test('');        // true
 * /^0*$/.test('000');     // true
 * /^0*$/.test('00100');   // false
 */
export const ONLY_ZEROS_PATTERN = /^0*$/;

/**@description A regex pattern to match all the invalid characters in a sharepoint file name */
export const INVALID_SHAREPOINT_CHARS_PATTERN = /[$#&%"*:<>{}+?/\\|~]/g;
